import { gql } from "@apollo/client";

const count = gql`
  query Query(
    $filterCountApplication: FilterCountTalentInput,
    $filterCountListing: FilterCountListingInput
  ) {
    talentCount(filter: $filterCountApplication)
    listingCount(filter: $filterCountListing)
  }
`;

const query = gql`
  query Query(
    $filterListingCount: FilterCountListingInput,
    $filterListing: FilterFindManyListingInput,
    $sort: SortFindManyListingInput,
    $limit: Int,
    $skip: Int
  ) {
    listingCount(
      filter: $filterListingCount
    )
    listingFindMany(
      filter: $filterListing,
      sort: $sort,
      limit: $limit,
      skip: $skip
    ) {
      _id
      listingId
      createdDate
      details
      subscribed
    }
  }
`;

const status = gql`
  query Query($id: MongoID!) {
    listingFindId(_id: $id) {
      updating
    }
  }
`;

export default {
  count,
  query,
  status,
};
